module.exports = __webpack_public_path__ + "static/media/bulle-racines.6b8d9e5e.png";